export default __webpack_public_path__ + "media/images/map-pin-856ba77fb96cb31e3c440d7523cba89b.png";